import { PopupResponseEvents } from '../enums/enums';
import { Genarations } from './Genaration';
import { MultiMediaBasicInfo } from './MultiMediaBasicInfo';
import { SunchartOptionInfo } from './SunchartOptionInfo';
import { PedigreeOptionInfo } from './ReportOptionInfo';
import { PlaceInfo } from './PlaceInfo';

export class PopupResponse {
    public Status: PopupResponseEvents;
    public Data: any[];
    public reload: boolean = false;
}

export class MultimediaPopupResponse extends PopupResponse {
    public Data: MultiMediaBasicInfo[] = new Array<MultiMediaBasicInfo>();
}

export class MemberEditorPopupResponse extends PopupResponse {

}

export class SunchartPopupResponse extends PopupResponse {
    public Info: SunchartOptionInfo = new SunchartOptionInfo();

}

export class PedigreePopupResponse extends PopupResponse {
    public Info: PedigreeOptionInfo = new PedigreeOptionInfo();

}

export class PlacePopupResponse extends PopupResponse{
    public Info: PlaceInfo = new PlaceInfo();

}